import { Injectable } from "@angular/core";
import { Router } from "@angular/router";


@Injectable({
	providedIn: 'root'
})
export class SessionService {
	
	private _employerID: string;
	constructor(private router: Router) {}

	logout() {
		this.router.navigate(['/', 'login']);
	}
	get visitorID() {
		let visitorId = localStorage.getItem('visitorID');
		if (!visitorId) {
			visitorId = crypto.randomUUID();
			localStorage.setItem('visitorID', visitorId);
		}
		return visitorId;
	}

	get sessionID() {
		let sessionId = sessionStorage.getItem('sessionID');
		if(!sessionId) {
			sessionId = crypto.randomUUID();
			sessionStorage.setItem('sessionID', sessionId);
		}
		return sessionId;
	}

	get employerID() {
		return this._employerID;
	}
	set employerID(employerID: string) {
		this._employerID = employerID;
	}
}